import APGoogleBodyScript from './APGoogleBodyScript';

export {
  APGoogleBodyScript
};

export default APGoogleBodyScript;